import { Method } from '@rxap/utilities';
import { OpenApiMethod, HttpMethods, BaseOpenApiMethod, OpenApiParameterType } from '../../open-api.method';
import { config } from '../../../config';
import { ProductControllerGetProductListResponse } from '../../responses/product-controller-get-product-list.response';

@OpenApiMethod({
  method: HttpMethods.GET,
  apiName: 'customer',
  path: '/product/list',
  operationId: 'ProductController_getProductList',
  parameters: [
    {
      name: 'tenantId',
      required: true,
      in: OpenApiParameterType.QUERY,
    },
  ],
})
export class ProductControllerGetProductListMethod
  extends BaseOpenApiMethod<ProductControllerGetProductListResponse>
  implements Method<ProductControllerGetProductListResponse, void>
{
  public call(): Promise<ProductControllerGetProductListResponse> {
    return super.call({
      parameters: {
        tenantId: config.tenantId,
      },
    });
  }
}
